
var sLOG_SOURCE = "vcHeaderMenu.JS.";

function vcHeaderMenu() {

    
    this.addHeaderMenu = function (vcvid, vcgid, prefix, bShowHelp) {
    	try {
    		var header = $('#' + prefix + vcgid);

    		header.find('.imgHeaderMenu').click(function () {
    			
    			if (header.find('.divSettingsMenu').is(':visible')) {
    				header.find('.divSettingsMenu').hide();
    			} else {
    				header.find('.divSettingsMenu').show();
    			}
    		});

    		if (bShowHelp) {
    			header.find('.btnHelp').click(function () {
    			    window.VisualCoreService.showHelp(vcvid, vcgid,
                        function (result) {
                            header.find('.divSettingsMenu').hide(); 
                        	$('#vcHeaderMenu' + vcgid).html(result);
                        	eval($('#vcHeaderMenu' + vcgid));
                        	$('#vcBase' + vcgid).hide();
                        	$('#vcHeaderMenu' + vcgid).fadeIn(500);
                        	return false;
                        });
    			});
    		}
    		
    	} catch (ex) { writeError(sLOG_SOURCE + "addHeaderMenu", ex); }
    }

    this.adjustHeight = function (vcgid, space) {
        try {
            var h = $('#vcBase' + vcgid).height();
            $('#vcHeaderMenu' + vcgid).height(h);
            h = h - space;
            $('#vcHeaderMenuContent' + vcgid).css('max-height', h).css('min-height', h).css('overflow', 'auto');
        } catch (ex) { writeError(sLOG_SOURCE + "adjustHeight", ex); }
    }

    this.addClose = function (vcgid) {
        try {
            $('.btnClose' + vcgid).button();
            $('.btnClose' + vcgid).click(function () {
               $('#vcHeaderMenu' + vcgid).hide();
               $('#vcBase' + vcgid).fadeIn(500);
            });
        } catch (ex) { writeError(sLOG_SOURCE + "addClose", ex); }
    }

}


